module.exports = __webpack_public_path__ + "img/2025-05-09a_6.60d85349.jpg";